import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';

import { UserListFilters } from './user-list-filters.component';
import { userListColumns } from './user-list.column';
import { useUserList } from './user-list.hook';

export const UserList = () => {
    const { data, isLoading, isError, isFetching, error } = useUserList();

    return (
        <SectionContainer isError={isError} error={error} isLoading={isLoading}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb items={[{ label: 'Users' }]} />
                        <SectionTitle>User List</SectionTitle>
                    </div>

                    <div className={'flex gap-2'}>
                        <Button type={'button'} variant={'outline'}>
                            <Link to={Route.ROLES}>Roles and Permissions</Link>
                        </Button>
                        <Button type={'button'}>
                            <Link to={Route.USER_CREATE}>Create New User</Link>
                        </Button>
                    </div>
                </div>

                <UserListFilters />
                <SectionDataTable
                    columns={userListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

UserList.displayName = 'UserList';
